export const publicRoutes = [
  {
    path: "/",
    name: "login",
    props: true,
    params: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/Login.vue"),
    meta: { title: "Login", requiresAuth: false },
  },
  {
    path: "/politicas-privacidade",
    name: "politicas-privacidade",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/PoliticaPrivacidade.vue"),
    meta: {
      title: "Políticas de Privacidade",
      requiresAuth: false,
    },
  },
  {
    path: "/usuario-loja-redefinir-senha",
    name: "redefinir-senha-lojista",
    props: true,
    params: true,
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/producers/RedefinePassword.vue"
      ),
    meta: { title: "Redefinir Senha", requiresAuth: true },
  },
  {
    path: "/primeiros-passos",
    name: "primeiros-passos",
    props: true,
    params: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/FirstSteps.vue"),
    meta: { title: "Primeiros Passos", requiresAuth: true },
  },
  {
    path: "/recuperar-senha-lojista",
    name: "recuperar-senha-lojista",
    props: true,
    params: true,
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/producers/users/ProducerRecoveryPassword.vue"
      ),
    meta: { title: "Recuperar senha", requiresAuth: false },
  },
  {
    path: "/recuperar-senha-afiliado",
    name: "recuperar-senha-afiliado",
    props: true,
    params: true,
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/producers/users/AffiliateRecoveryPassword.vue"
      ),
    meta: { title: "Recuperar senha", requiresAuth: false },
  },
  {
    path: "/status",
    name: "status",
    props: true,
    params: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/status/StatusAPI.vue"),
    meta: { title: "Status", requiresAuth: false },
  },
  {
    path: "*",
    name: "Error",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/Error.vue"),
    meta: {
      title: "Página não encontrada",
      requiresAuth: false,
    },
  },
  {
    path: "/afiliado/cadastro/:id",
    name: "RegisterAffiliate",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/RegisterAffiliate.vue"),
    meta: {
      title: "Cadastro de Afiliado",
      requiresAuth: false,
    },
  },
];
